import type { ProjectAssignOptions } from "./project-assign.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";
import type { QueryInvalidateTarget } from "@/services/query";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

export const useProjectAssign = (
  projectId: number,
  options?: ProjectAssignOptions
) => {
  const defaultInvalidate: QueryInvalidateTarget[] = [
    ["projects", "list"],
    ["projects", "get", projectId],
  ];

  const onSuccess = useMutationOnSuccess({ ...options, defaultInvalidate });

  const mutationFn = (users: number[]) => {
    return client.projects.assign(projectId, users);
  };

  return useMutation<ApiEmptyResponse, ApiError, number[]>({
    mutationFn,
    onSuccess,
  });
};
